import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorMsg("");

  try {
    const basicAuth = btoa(`${email}:${password}`);
    const res = await fetch("https://reactraptorid.onrender.com/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${basicAuth}`,
      },
      body: JSON.stringify({ username: email, password }),
    });

    const data = await res.json();

    if (!res.ok) {
      setErrorMsg(data.error || "Login failed");
      return;
    }

    login(data.token, email);
    navigate("/identify");

  } catch (err) {
    console.error("Login error:", err);
    setErrorMsg("Something went wrong. Please try again");
  }
};


  return (
<div className="container">
  <h2 className="text-center">Login to RaptorID</h2>

  <form className="bird-form" onSubmit={handleSubmit}>
    <label>Email:</label>
    <input
      type="email"
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      required
    />

    <label>Password:</label>
    <input
      type="password"
      value={password}
      onChange={(e) => setPassword(e.target.value)}
      required
    />

    <button type="submit">Log In</button>
  </form>

  {errorMsg && <p style={{ color: "red", marginTop: "10px" }}>{errorMsg}</p>}

   <footer style={{ textAlign: "center", marginTop: "40px", fontSize: "14px", color: "#444" }}>
     Made with 🦅 and 🌿 by Louise
   </footer>

</div>

  );
}

export default Login;
